/*
 * @Author: yanhua 
 * @Date: 2020-12-18 10:28:13 
 * @Last Modified by: yanhua
 * @Last Modified time: 2020-12-18 18:18:36
 */
import axios from '../utils/http';
// 用户列表
const pageList = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/all'
    });
};
//封禁/小黑屋
const isbanned = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/isbanned'
    })
}
//解禁
const unbanned = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/unbanned'
    })
}
//长描述
const longDesc = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/longDesc'
    })
}
//设置加V
const setident = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/setident'
    })
}
//取消加V
const unsetident = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/unsetident'
    })
}
//设置学生身份
const studentidentity = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/studentidentity'
    })
}
//设置老师身份
const teacheridentity = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/teacheridentity'
    })
}
//设置pro
const setpro = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/setpro'
    })
}
//取消pro身份
const unpro = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/unpro'
    })
}
//设置官方
const setofficial = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/setofficial'
    })
}
//取消官方身份
const unofficial = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/unofficial'
    })
}
//设置用户所在学校
const setcollege = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/setcollege'
    })
}
//院校列表
const schoollist = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/schoollist'
    })
}
//省份列表
const provincelist = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/provincelist'
    })
}
//添加合作画室
const studioadd = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/studioadd'
    })
}
//后台用户注册
const fakeuser = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/fakeuser'
    })
}
//修改用户昵称信息
const updatenickname = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/updatenickname'
    })
}
//身份列表
const gradelist = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/gradelist'
    })
}
//获取用户信息
const getuserinfo = param => {
    return axios.request({
        data: {
            ...param
        },
        headers:{'Authorization':'bearer '+localStorage.getItem('token')},
        method: 'post',
        url: '/v6/getUser'
    })
}
//修改用户信息
const updateuserinfo = param => {
    return axios.request({
        data: {
            ...param
        },
        method: 'post',
        url: '/admin/user/updateuserinfo'
    })
}

export default {
    getuserinfo,
    // pageList,
    // isbanned,
    // unbanned,
    // longDesc,
    // setident,
    // unsetident,
    // studentidentity,
    // teacheridentity,
    // setpro,
    // unpro,
    // setofficial,
    // unofficial,
    // setcollege,
    // schoollist,
    // provincelist,
    // studioadd,
    // fakeuser,
    // updatenickname,
    // gradelist,
    // updateuserinfo
};
